import React from 'react';
import { useLocation } from 'react-router-dom';
import { LoginEmployee } from '../../../../../server-types';
import LoginFormView, { LoginFormProps } from './LoginFormView';
import { useMutation } from '../../../../../graphql/hooks';
import { LOGIN_EMPLOYEE } from '../../../graphql';
import { useAuth } from '../../../../../utils/hooks/auth';

interface MutationResult {
    loginEmployee: string;
}

export interface LocationState {
    referrer: Location;
}

const LoginForm = (props: Omit<LoginFormProps, 'onSubmit'>) => {
    const [login] = useMutation<MutationResult>(LOGIN_EMPLOYEE);
    const { login : loginUser } = useAuth();
    const { state } = useLocation<LocationState>();
    const { referrer } = state || { referrer: { pathname: '/' } };

    const onSubmit = async (values: LoginEmployee) => {
        const { data } = await login({ variables: values });
        if (data) {
            loginUser({ token: data.loginEmployee, referrer });
        }
    };


    return <LoginFormView {...props} onSubmit={onSubmit} />;
};

export default LoginForm;
